module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "home"
  }, [_h('div', {
    staticClass: "container"
  }, [_h('h1', {
    staticClass: "text-xs-center"
  }, ["Panel de control WPO WEBSITE"])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-267673c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 198
// module chunks = 2